import axios from './axios'
import qs from "qs";

function service(endpoint) {

    function send(data) {
        return axios.post(`${endpoint}/send`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function preview(id, data) {
        return axios.get(`${endpoint}/${id}/preview`, { headers: { Accept: 'text/html' }, params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function test(id, data) {
        return axios.post(`${endpoint}/${id}/test`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    return {
        preview,
        send,
        test
    }
}

export default service
